import { useEffect } from 'react';

import { loadHighContrastEmulationStylesheet } from './lazyExports';

type UseLoadHighContrastEmulationStyles = (emulateHighContrast: boolean) => void;
export const useLoadHighContrastEmulationStyles: UseLoadHighContrastEmulationStyles = (emulateHighContrast) => {
  useEffect(() => {
    if (emulateHighContrast) {
      void loadHighContrastEmulationStylesheet();
    }
  }, [emulateHighContrast]);
};
